module.exports = __webpack_public_path__ + "img/upload-file.b77ba76e.svg";